<template>
    <div id="newsInfo" class="newsInfo">
            <img :src="list.logo" alt="" class="banner-img" ondragstart="return false;" oncontextmenu="return false;">
        <div class="banner">
            <div class="banner-description">
            <div class="name">{{list.title1}}</div>
             <div class="description">{{list.title1s}}</div>
           </div>
        </div>
           <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup"></i>
                <h1>{{list.title1}}</h1>
                <h3>{{list.title1s}}</h3>
            </div>
        </div>
        <div class="endowloadDetail-contaniner" >
              <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen">
                    <div class="nav-text"  @click="gethisList('',-1,'pageSize')"
                    :class="{ active: currentNav == -1 }"
                    >全部</div>
                <div class="nav-text"
                 v-for="(item,index) in classfy"
                :key="index"
                :class="{ active: currentNav == index }"
                 @click="gethisList(item.id,index,'pageSize')"
                >{{item.name}}</div>
                </div>
                </div>
          </div>
          <div class="card-container" v-if="platformAppContentList.length">
                <div class="containers">
                    <div class="list">
                        <div class="itemList flex align-cen"
                          v-for="(item,index) in platformAppContentList"
                            :key="item.id"
                            @click="openDetail(item)"
                        >
                            <div class="img">
                                 <img :src="item.pic || require('../../../assets/images/defuletNews.jpg')" alt="">
                            </div>
                            <div class="imgInfo">
                                <div class="title">{{item.name}}</div>
                                <p class="dateTit"> <span class="el-icon-date"></span>  <span class="data">{{item.createTime}}</span> </p>
                                <!-- <p class="newInfo newInfoimg" v-html="item.content"></p> -->
                                <p class="infoClick"><span class="detail">查看详情+</span></p>
                            </div>
                        </div>
                    </div>
                     <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                </div>
          </div>
          <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div>
        </div>
        <goTop></goTop>
    </div>
      
</template>
<script>
import {pageList,newsClassify,newPageList} from "@/api/enterprise/index" // 配置详情、新闻分类列表、新闻列表
import debounce from '../../../utils/debounce.js' //防抖
import goTop from '@/components/goTop'
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'newsInfo',
    components:{
        goTop,
        paginaTion
    },
    data () {
        return {
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            classfy:[],
            platformAppContentList:[],
            currentNav:-1,
            tabPosition:'top',
            isFixed: false,
            isClick:false,
            contentTopList:[],
            fristId:'',
            list:{
                logo:'',
                title1:'',
                title1s:'',
            }
        }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll) // 监听滑动事件  
    },
    created () {
        document.title = "新闻动态"
        let that = this
             this.getDetail()
         //    异步同步执行
            this.getClassfy().then(function(){
            that.gethisList(that.fristId,-1)
            })
    },
    methods: {
          // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList(this.fristId,this.currentNav)
      },
        handleScroll(){
            var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
         var offsetTop = document.querySelector('.banner').offsetHeight
         // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
        },
        // 打开详情
        openDetail(data){
             if(data.type == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
                  const newurl = this.$router.resolve({name: 'enNewsDetail', query: {id: data.id}})
                window.open(newurl.href,'_blank')
             }
        },
          // 获取详情
          getDetail(){
              pageList({id:3},'enterprise')
                .then(res => {
                 res.data.forEach(item =>{
                     if(item.attributeName == "logo")   this.list.logo  = item.attributeValue
                    if(item.attributeName == "title1")  this.list.title1  = item.attributeValue
                    if(item.attributeName == "title1s") this.list.title1s  = item.attributeValue
                 })
                
                })
                .catch(err => {                  
                })
        },
        async getClassfy(){
            await newsClassify({},'enterprise')
            .then(res =>{
                this.classfy = res.data
            })
            .catch(err =>{})
        },
         // 获取新闻列表
        gethisList(id,index,page){
            this.fristId = id
            this.currentNav = index
            if(page){
                this.PageSize = 10
                this.currentPage = 1
            }
            newPageList({
                id:id,
                size:this.PageSize,
                current:this.currentPage,
            },'enterprise')
            .then(res =>{
                this.platformAppContentList = res.data.records
                this.totalCount = res.data.total
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.newsInfo{
    position: relative;
    .item-gradient{
        display: none;
    }
        .banner-img{
            width: 100%;
            height: 396px;
            object-fit: cover;
        }
    .banner{
        
        position: absolute;
           top:0px;
        width: 100%;
        height: 396px;
           .banner-description{
            position: absolute;
            left: 15%;
            top: 45%;
            color: #fff;
            .name{
                color: #171717;
                font-size: 40px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #171717;
                line-height: 50px;
            }
            .description{
                font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #171717;
            line-height: 50px;
            }
    }
    }
      .fixed{
         position: fixed;
        top: 0px;
        left: 0;
        right: 0;
        z-index: 10;

      }
    .card-container{
        width: 100%;
        margin: 0 auto;
        padding-bottom: 62px;
        margin-top: 20px;
        .containers{
            max-width: 1540px;
            padding: 0 15px;
            margin: 0 auto;
            .list{
                .itemList{
                 border-bottom: 1px solid #EEEEEE;
                 padding: 36px 0;
                 .img{
                    width: 20%;
                    vertical-align: middle;
                    img{
                        width: 100%;
                            object-fit: cover;
                            width: 100%;
                            height: 196px;
                            max-height: 196px
                    }
                 }
                 .imgInfo{
                    width: 75%;
                    vertical-align: middle;
                    padding-left: 56px;
                    cursor: pointer;
                    .title{
                    font-size: 20px;
                    color: #333333;
                    max-width: 650px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    }
                    p{
                        cursor: pointer;
                    }
                    .dateTit{
                        padding: 19px 0;
                        span{
                            color: #666;
                        }
                        .data{
                            font-size: 14px;
                            font-weight: 500;
                            line-height: 30px;
                            padding-left: 10px;
                        }
                    }
                    .newInfo{
                        font-size: 14px;
                        font-weight: 500;
                        color: #999999;
                        line-height: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                       p{
                         img{display: none !important;}
                       }
                    }
                    .infoClick{
                        padding-top: 24px;
                        span{
                            font-size: 16px;
                            font-weight: 500;
                            color: #666666;
                            line-height: 24px;

                        }
                    }
                 }
                }
                .itemList:hover{
                        background: #F6F6F6;
                        .imgInfo{
                            .title{
                                color: #2893f1;
                            }
                            .infoClick{
                                span{color: #2893f1;}
                            }
                        }
                }
            }
        }
    }
}
@media screen and (max-width: 1600px){
    .containers{
        max-width: 1200px !important;
        margin: auto;
    }
}
@media (max-width: 640px){
    .itemList{
        display: block;
        .img,.imgInfo{
            width: 100% !important;
        }
        .imgInfo{
            padding-left: 0 !important;
            margin-top: 10px;
            .title{
                -webkit-line-clamp:3 !important
            }
            .dateTit{
                padding: 2px 0 !important;
            }
            .infoClick{
                padding-top: 5px !important;
            }
        }
    }
     .banner{display: none;}
        .banner-img{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
       .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
       }
    }
}
@media (max-width: 640px){
#newsInfo{
  .banner-img{
    height: auto;
  }
  .containers{
    width: auto;
  }
}
}
::v-deep{
    .newInfoimg{
        *{
            font-size: 14px;
            color: #999 !important;
        }
        .ql-align-center{
            text-align: left;
        }
         p{
                         img{display: none !important;}
                       }
    }
      @media (max-width: 640px){
    .el-pagination__jump{
      margin-left: 0 !important;
    }
  }
        .jiange {
        margin-top: 62px !important;
        text-align: center;
    }
}
</style>